import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { SessionGate } from './components/SessionGate';
import { OverviewPage } from './pages/OverviewPage';
import { DetailPage } from './pages/DetailPage';

/**
 * Kein eigener Login: `SessionGate` kapselt `RequireAuth` aus `@sdc/auth` – ohne
 * Session geht es zum Hub-Login, mit Session hierher. Der Wartezustand ist
 * sichtbar und laeuft in einen Timeout, damit kein leerer Bildschirm entsteht.
 * Die Rolle `admin` prueft der Server bei jedem API-Call.
 *
 * `Layout` bringt den `.page`-Wrapper mit, ohne den der Inhalt hinter dem
 * fixierten Hintergrund verschwindet.
 */
export function App() {
  return (
    <BrowserRouter>
      <SessionGate>
        <Layout>
          <Routes>
            <Route path="/" element={<OverviewPage />} />
            <Route path="/ma/:id" element={<DetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </SessionGate>
    </BrowserRouter>
  );
}
